import hPreview from './src/h-preview'

hPreview.install = function (Vue) {
  Vue.component(hPreview.name, hPreview);
};

export default hPreview;